import {
  Box3,
  BoxGeometry,
  BufferGeometry,
  Mesh,
  type Ray,
  Raycaster,
  type Vector3
} from "three";

import type { WorldObjectAPI } from "../WorldObject";

export interface RaycastHit<WorldObjectType extends WorldObjectAPI> {
  worldObject: WorldObjectType;
  point: Vector3;
}

const raycaster = new Raycaster();
const boxGeom = new BoxGeometry(2, 2, 2);
const boxMesh = new Mesh(boxGeom);
const bbox = new Box3();

// NOTE: possible to optimize with a spatial index (such as an Octree or K-D tree)
//       if this starts to become expensive
export function raycastWorldObjects<WorldObjectType extends WorldObjectAPI>(
  ray: Ray,
  worldObjects: Iterable<WorldObjectType>
): RaycastHit<WorldObjectType> | null {
  raycaster.ray.copy(ray);

  let nearestHit: RaycastHit<WorldObjectType> | null = null;
  let nearestDistance = Infinity;
  for (const worldObject of worldObjects) {
    bbox.makeEmpty().expandByObject(worldObject.root);
    bbox.getCenter(boxMesh.position);
    bbox.getSize(boxMesh.scale);
    boxMesh.updateMatrix();
    boxMesh.updateMatrixWorld();
    const boxIntersection = raycaster.intersectObject(boxMesh, false).at(0);
    if (!boxIntersection) continue;
    const intersection = raycaster.intersectObject(worldObject.root).at(0);
    if (!intersection || intersection.distance >= nearestDistance) continue;
    nearestDistance = intersection.distance;
    nearestHit = { worldObject, point: intersection.point };
  }
  return nearestHit;
}
